export const GET_WEBHOOKS = 'GET_WEBHOOKS'
export const GET_SPECIFIC_WEBHOOK = 'GET_SPECIFIC_WEBHOOK'
export const GET_ALL_ROUTES = 'GET_ALL_ROUTES'
export const GET_ALL_QUEUES = 'GET_ALL_QUEUES'
export const GET_ALL_AGENTS = 'GET_ALL_AGENTS'
export const LISTAR_GRUPOS_DE_ROTAS = 'LISTAR_GRUPOS_DE_ROTAS'
